import apolloClient from "core/graphql/apolloClient";
import customerActions from "../actions";
import commonActions from "../../common/actions";
import queryActions from "../../queries/actions";
import queryLoader from "core/graphql/queryLoader";
import messagesActions from "../../messages/actions";
// import messagesActionTypes from "../../messages/types";
// import { pendingTask, end } from "react-redux-spinner";

// const ADD_MESSAGE = messagesActionTypes.ADD_MESSAGE;

export default async (store, action) => {
  if (!action.token || action.token === "") {
    store.dispatch(
      messagesActions.addMessage(
        "You are missing the reset password token. Please send another reset password request",
        "danger"
      )
    );
    store.dispatch(commonActions.unlock());
    return;
  }

  if (
    !action.password ||
    action.password === "" ||
    !action.confirmPassword ||
    action.confirmPassword === "" ||
    action.password !== action.confirmPassword
  ) {
    store.dispatch(
      messagesActions.addMessage("Please confirm your password.", "danger")
    );
    store.dispatch(commonActions.unlock());
    return;
  }

  try {
    let request = {
      input: {
        token: action.token,
        password: action.password,
        password_confirm: action.confirmPassword
      }
    };

    const { data } = await apolloClient.mutate({
      mutation: queryLoader("resetCustomerPassword"),
      variables: request
    });
    if (data) {
      // dispatch error codes from graphql
      store.dispatch(customerActions.resetCustomerPasswordSuccess(true));
      store.dispatch(
        messagesActions.addMessage(
          data.resetPassword.message,
          data.resetPassword.code
        )
      );
    }
  } catch (error) {
    store.dispatch(messagesActions.addMessage(error.toString(), "danger"));
    store.dispatch(commonActions.unlock());
    store.dispatch(queryActions.removeQuery());
    return;
  }
};
